import { useEvent } from '@tencent/dz-runtime';
export var REPORT_EVENT_KEY = 'REPORT_EVENT_KEY';
export var useReport = function () {
    var reportInstance = useEvent(REPORT_EVENT_KEY);
    return reportInstance;
};
